module.exports = __webpack_public_path__ + "img/lino.283a2c25.png";